import React from 'react'
import './style.css';
import { Modal, Table } from '@vwfs-bronson/bronson-react'
import { IBillingError } from '../../../models/customer-data.interface'
import { formatter } from '../../../utils/time-utils';

interface ErrorsModalInterface {
  errors: IBillingError[],
  showModal: boolean,
  handleOnClose: () => void
}

export default function BookingErrorsModal({ errors, showModal, handleOnClose }: ErrorsModalInterface) {
  const renderInvoiceTable = () => {
    return (
      <Table colored={true} testId="test-invoices-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Time</Table.Th>
            <Table.Th>Details</Table.Th>
          </Table.Tr>
          {
            errors.map(error => {
              const errorDetails = error.code + ", " + (error.message ? error.message : error.details ? error.details : "" ) || "";
              return (
                <Table.Tr key={error.code + '_' + error.timestamp} className="table-row">
                  <Table.Td>{error.timestamp ? formatter.format(new Date(error.timestamp)) : ""}</Table.Td>
                  <Table.Td style={{ maxWidth: '350px' }}>{errorDetails}</Table.Td>
                </Table.Tr>)
            })
          }
        </Table.Thead>
      </Table >
    )
  }

  return <Modal
    shown={showModal}
    onClose={handleOnClose}
    onConfirm={handleOnClose}
    buttonConfirmLabel="Ok"
    buttonConfirmText="Ok"
    title={`Errors`}
    large={true}
    status='info'
    testId='test-invoices-table-modal'>
    {renderInvoiceTable()}
  </Modal>
}
